/* eslint-disable @typescript-eslint/naming-convention */
import { Action, createReducer, on } from '@ngrx/store';
import { saveUserPreferenceDetailSuccess } from 'src/app/pages/user-preferences/state/user-preference-detail.actions';
import * as AppStartActions from '../../app-start/app-start.actions';
import * as AuthenticationActions from '../../authentication/state/authentication.actions';
import { EffectiveUserPreferences } from './user-preferences';
import * as UserPreferencesActions from './user-preferences.actions';

export const userPreferencesFeatureKey = 'userPreferencesCore';

export interface State {
   userPreferences: EffectiveUserPreferences | null;
}

export const initialState: State = {
   userPreferences: null,
};

const userPreferenceDefinitionsReducer = createReducer(
   initialState,
   on(AuthenticationActions.loginSuccess, AppStartActions.authenticationVerificationSuccess, (state, action) => {
      return {
         ...state,
         userPreferences: action.loginResult.UserPreferences,
      };
   }),
   on(UserPreferencesActions.saveExpandMenuSuccess, UserPreferencesActions.saveExpandMenu, (state, action) => {
      return state.userPreferences
         ? {
              ...state,
              userPreferences: { ...state.userPreferences, ExpandMenu: action.expandMenu },
           }
         : state;
   }),
   on(
      UserPreferencesActions.saveSelectedDashboardIdSuccess,
      UserPreferencesActions.saveSelectedDashboardId,
      (state, action) => {
         return state.userPreferences
            ? {
                 ...state,
                 userPreferences: { ...state.userPreferences, SelectedDashboardId: action.selectedDashboardId },
              }
            : state;
      }
   ),
   on(
      UserPreferencesActions.saveMostRecentDeviceTypeSuccess,
      UserPreferencesActions.saveMostRecentDeviceType,
      (state, action) => {
         return state.userPreferences
            ? {
                 ...state,
                 userPreferences: { ...state.userPreferences, mostRecentDeviceType: action.mostRecentDeviceType },
              }
            : state;
      }
   ),
   on(
      UserPreferencesActions.saveShowExtensionRegisterPopupSuccess,
      UserPreferencesActions.saveShowExtensionRegisterPopup,
      (state, action) => {
         return state.userPreferences
            ? {
                 ...state,
                 userPreferences: {
                    ...state.userPreferences,
                    ShowExtensionRegisterPopup: action.showExtensionRegisterPopup,
                 },
              }
            : state;
      }
   ),
   on(
      UserPreferencesActions.saveQueueHistoryRegisterWrapQueuesSuccess,
      UserPreferencesActions.saveQueueHistoryRegisterWrapQueues,
      (state, action) => {
         return state.userPreferences
            ? {
                 ...state,
                 userPreferences: {
                    ...state.userPreferences,
                    QueueHistoryRegisterWrapQueues: action.queueHistoryRegisterWrapQueues,
                 },
              }
            : state;
      }
   ),
   on(
      UserPreferencesActions.saveExpandCallDetailAdvancedSectionSuccess,
      UserPreferencesActions.saveExpandCallDetailAdvancedSection,
      (state, action) => {
         return state.userPreferences
            ? {
                 ...state,
                 userPreferences: {
                    ...state.userPreferences,
                    ExpandCallDetailAdvancedSection: action.expandCallDetailAdvancedSection,
                 },
              }
            : state;
      }
   ),
   on(saveUserPreferenceDetailSuccess, (state, { userPreferenceSubmitValue }) => {
      if (!state.userPreferences) {
         return state;
      }

      return {
         ...state,
         userPreferences: {
            ...state.userPreferences,
            UseAlternatingRowColors: userPreferenceSubmitValue.useAlternatingRowColors,
         },
      };
   })
);

export function reducer(state: State | undefined, action: Action) {
   return userPreferenceDefinitionsReducer(state, action);
}
